function e(o) {
  return o === window;
}
var c = /scroll|auto|overlay/i;
function f(o, t) {
  t === void 0 && (t = window);
  for (var n = o; n && n.tagName !== "HTML" && n.tagName !== "BODY" && n.nodeType === 1 && n !== t;) {
    var i = window.getComputedStyle(n),
      l = i.overflowY;
    if (c.test(l)) return n;
    n = n.parentNode;
  }
  return t;
}
function u(o) {
  var t = "scrollTop" in o ? o.scrollTop : o.pageYOffset;
  return Math.max(t, 0);
}
function r(o, t) {
  "scrollTop" in o ? o.scrollTop = t : o.scrollTo(o.scrollX, t);
}
function p() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}
function g(o) {
  r(window, o), r(document.body, o);
}
function d(o, t) {
  if (e(o)) return 0;
  var n = t ? u(t) : p();
  return o.getBoundingClientRect().top + n;
}
function s(o) {
  return e(o) ? o.innerHeight : o.getBoundingClientRect().height;
}
function T(o) {
  return e(o) ? 0 : o.getBoundingClientRect().top;
}
export { d as getElementTop, p as getRootScrollTop, u as getScrollTop, f as getScroller, s as getVisibleHeight, T as getVisibleTop, g as setRootScrollTop, r as setScrollTop };
